import { useMemo } from 'react'

import {
	FeatureFlag,
	getFeatureFlagConfig,
	resolveEnvironment,
} from '@/app/config/feature-flags'

export const useFeatureFlags = () => {
	const environment = resolveEnvironment(process.env.NEXT_PUBLIC_APP_ENV)

	const isEnabled = useMemo(() => {
		return (flag: FeatureFlag, language?: string) => {
			const config = getFeatureFlagConfig(flag, environment)
			if (!config.enabled) return false
			if (!config.languages || config.languages.length === 0) return true
			return !!language && config.languages.includes(language)
		}
	}, [environment])

	return { isEnabled }
}
